import OverviewView from './OverviewView'
import overviewViewContainer from './overviewViewContainer'

export default overviewViewContainer(OverviewView)
